import React from "react";
import { TextField, MenuItem } from "@mui/material";

const InputSelect = ({
  label,
  id,
  value,
  onChange,
  options = [],
  error,
  disabled = false,
  helperText = "",
}) => {
  return (
    <TextField
      select
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      fullWidth
      size="small"
      variant="outlined"
      disabled={disabled}
      error={!!error}
      helperText={error || helperText}
      sx={{
        "& .Mui-disabled": {
          backgroundColor: "#EBEBEB",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#DEDEDE !important",
            borderWidth: "1px !important",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#DEDEDE !important",
          },
          "& .MuiInputBase-input": {
            color: "#616161",
            "-webkit-text-fill-color": "#616161",
            "&::placeholder": {
              color: "#9e9e9e",
              opacity: 1,
              fontWeight: "normal",
              "-webkit-text-fill-color": "#9e9e9e",
            },
          },
          "& .MuiInputAdornment-root": {
            color: "#A0A0A0",
          },
        },
      }}>
      {options.map((option, index) => (
        <MenuItem key={index} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default InputSelect;
